import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_button_dropdown = _resolveComponent("button-dropdown")!

  return (_ctx.invoice)
    ? (_openBlock(), _createBlock(_component_button_dropdown, {
        key: 0,
        title: "Выберите действие",
        class: "ml-2",
        placement: "bottom",
        "allowed-placements": ['bottom']
      }, {
        default: _withCtx(() => [
          (_ctx.havePermissions(['cabinet.invoice-places-update-signing-properties', 'all-root-permission']))
            ? (_openBlock(), _createBlock(_component_the_button, {
                key: 0,
                loading: _ctx.propertiesLoading,
                class: "primary text small",
                onClick: _ctx.emitProperties
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Обновить статус подписания ")
                ]),
                _: 1
              }, 8, ["loading", "onClick"]))
            : _createCommentVNode("", true),
          (_ctx.isWaitList)
            ? (_openBlock(), _createBlock(_component_the_button, {
                key: 1,
                class: "primary text small",
                onClick: _ctx.emitWaitList,
                loading: _ctx.waitListLoading
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Добавить в ЛО ")
                ]),
                _: 1
              }, 8, ["onClick", "loading"]))
            : _createCommentVNode("", true),
          (Boolean(_ctx.invoice.attachment_url) && _ctx.invoice.type !== 1)
            ? (_openBlock(), _createElementBlock("a", {
                key: 2,
                download: "",
                target: "_blank",
                href: _ctx.invoice.attachment_url
              }, [
                _createVNode(_component_the_button, { class: "text small primary" }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Скачать скан ")
                  ]),
                  _: 1
                })
              ], 8, _hoisted_1))
            : _createCommentVNode("", true),
          (Boolean(_ctx.invoice) && _ctx.invoice.type !== 1)
            ? (_openBlock(), _createBlock(_component_the_button, {
                key: 3,
                class: "primary text small",
                onClick: _ctx.emitDeclaredPrice
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Внести объявленную стоимость ")
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (Boolean(_ctx.invoice) && _ctx.invoice.isArrested)
            ? (_openBlock(), _createBlock(_component_the_button, {
                key: 4,
                class: "primary text small",
                loading: _ctx.state.is_arresting,
                onClick: _ctx.unarrestInvoice
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Разблокировка выдачи ")
                ]),
                _: 1
              }, 8, ["loading", "onClick"]))
            : (_openBlock(), _createBlock(_component_the_button, {
                key: 5,
                class: "primary text small",
                loading: _ctx.state.is_arresting,
                onClick: _ctx.arrestInvoice
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Блокировка выдачи ")
                ]),
                _: 1
              }, 8, ["loading", "onClick"])),
          (_ctx.partialReturn)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                (
                    _ctx.havePermissions(['dispatcher.approve-delivery']) &&
                    (_ctx.invoice.status && ![211, 503].includes(_ctx.invoice.status.code)) &&
                    _ctx.isWaiting
                )
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: `/invoice/${_ctx.invoice.id}/partial-return`
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_the_button, { class: "primary text small" }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Проставить статус \"Доставлено\" ")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : _createCommentVNode("", true)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                (
                    _ctx.havePermissions(['dispatcher.approve-delivery']) &&
                    (_ctx.invoice.status && ![211, 503].includes(_ctx.invoice.status.code)) &&
                    _ctx.isWaiting
                )
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 0,
                      class: "primary text small",
                      onClick: _ctx.emitApproveDelivery
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Проставить статус \"Доставлено\" ")
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ], 64)),
          _createVNode(_component_the_button, {
            class: "primary text small",
            onClick: _ctx.emitPreviousStatus
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Проставить прошлый статус ")
            ]),
            _: 1
          }, 8, ["onClick"]),
          (_ctx.isVerify)
            ? (_openBlock(), _createBlock(_component_the_button, {
                key: 8,
                class: "primary text small",
                onClick: _ctx.emitVerify
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Обновление верификации ")
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.isCanUpdateInvoice)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 9,
                to: `/invoice/${_ctx.$route.params.invoice_id}/update-services`
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_the_button, { class: "primary text small" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Изменить доп. услуги ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true),
          (_ctx.isCanUpdateInvoiceNumber)
            ? (_openBlock(), _createBlock(_component_the_button, {
                key: 10,
                class: "primary text small",
                onClick: _ctx.emitChangeInvoiceNumber
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Изменить номер накладной ")
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.isPredictDate)
            ? (_openBlock(), _createBlock(_component_the_button, {
                key: 11,
                class: "primary text small",
                onClick: _ctx.emitPredictDate
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Перенести дату доставки ")
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.isCanUpdateInvoice)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 12,
                to: `/invoice/${_ctx.$route.params.invoice_id}/edit`
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_the_button, { class: "primary text small" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Редактировать накладную ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true),
          (Boolean(_ctx.invoice.invoice_number))
            ? (_openBlock(), _createBlock(_component_the_button, {
                key: 13,
                class: "primary text small",
                loading: _ctx.boxLoading,
                onClick: _ctx.emitSaveBox
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Сохранить коробку ")
                ]),
                _: 1
              }, 8, ["loading", "onClick"]))
            : _createCommentVNode("", true),
          (Boolean(_ctx.invoice.invoice_number))
            ? (_openBlock(), _createBlock(_component_the_button, {
                key: 14,
                class: "primary text small",
                loading: _ctx.loading,
                onClick: _ctx.emitPrintInvoice
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Печать ")
                ]),
                _: 1
              }, 8, ["loading", "onClick"]))
            : _createCommentVNode("", true),
          (_ctx.isCanResendToOneC)
            ? (_openBlock(), _createBlock(_component_the_button, {
                key: 15,
                class: "primary text small",
                loading: _ctx.state.is_resending_to_one_c,
                onClick: _ctx.resendToOneC
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Переотправить статус доставки ")
                ]),
                _: 1
              }, 8, ["loading", "onClick"]))
            : _createCommentVNode("", true),
          (_ctx.isCanCancelInvoice)
            ? (_openBlock(), _createBlock(_component_the_button, {
                key: 16,
                class: "red text small",
                loading: _ctx.state.is_cancelling,
                onClick: _ctx.cancelInvoice
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.getCancelBtnText), 1)
                ]),
                _: 1
              }, 8, ["loading", "onClick"]))
            : _createCommentVNode("", true),
          (_ctx.isRestore)
            ? (_openBlock(), _createBlock(_component_the_button, {
                key: 17,
                class: "primary text small",
                onClick: _ctx.emitRestore,
                loading: _ctx.restoreLoading
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Восстановить ")
                ]),
                _: 1
              }, 8, ["onClick", "loading"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}